import { useEffect, useRef, useState } from "react";
import NumericInput from "@weave-design/numeric-input";
import { AuxiliaryPropertyEditorControl } from "./auxiliaryPropertyEditorControl";
import { PropertyEditor } from "./propertyEditor";
import "./inputs.css";

type Props = {
    title: string;
    value: number;
    disabled?: boolean;
    auxiliaryControl?: AuxiliaryPropertyEditorControl;
    onChange: (newValue: number) => void;
};

// This editor works with numbers only. If you need to handle empty values too, use `NumberPropertyEditor`.
export const NumericPropertyEditor = ({ title, value, disabled, auxiliaryControl, onChange }: Props) => {
    const [editorValue, setEditorValue] = useState(value);
    const editorValueRef = useRef<number>(value);
    const idInputRef = useRef<HTMLInputElement>();

    useEffect(() => {
        updateValue(value);
    }, [value]);

    const updateValue = (newValue: number) => {
        editorValueRef.current = newValue;
        setEditorValue(newValue);
    };

    const saveValue = () => {
        if (editorValueRef.current === value) {
            return;
        }

        onChange(editorValueRef.current);
    };

    return (
        <PropertyEditor title={title} auxiliaryControl={auxiliaryControl}>
            <div style={{ width: "100%" }}>
                <NumericInput
                    inputRef={(x: HTMLInputElement) => (idInputRef.current = x)}
                    value={editorValue}
                    disabled={!!disabled}
                    onChange={(value: string) => updateValue(parseFloat(value))}
                    onBlur={() => saveValue()}
                />
            </div>
        </PropertyEditor>
    );
};
